<template>
  <div class="twelve columns">
    <find
      :url="url"
      :min-chars="5"
      :format-result="fmt"
      :format-popup="fmt"
      :query-param="queryParam"
      place-holder="Informe código, CPF/CNPJ ou nome do prestador"
      :item="resultado"
      :auto-select="true"
      @on-selected="onSelected"
      @on-clear="onClear"
    />
  </div>
</template>

<script>
import { formatcpfcnpj, formatDateRequest, buildURLQuery } from 'apsis-util';
import Find from './Find';

export default {
  components: { Find },
  props: {
    url: {
      type: String,
      default: 'findPrestador',
    },
    resultado: {
      type: Object,
      required: true,
    },
    data: {
      type: [String, Date],
      default: null,
      required: false,
    },
  },
  emits: ['onSelected', 'onClear', 'update:resultado'],
  computed: {
    queryParam() {
      if (this.data) {
        return buildURLQuery({ data: formatDateRequest(this.data) });
      }
      return '';
    },
  },
  methods: {
    onSelected(current) {
      this.$emit('update:resultado', current); // conjunto com o modificador .sync
      this.$emit('onSelected', current);
    },
    fmt(current) {
      const {
        adicional, prestadorJuridico, prestadorFisico, codigo, nome,
      } = current;

      const cpfCnpj = formatcpfcnpj(adicional)
        || prestadorJuridico?.cnpj
        || prestadorFisico?.cpf;

      if (!cpfCnpj) {
        return codigo ? `${codigo} - ${nome}` : '';
      }
      return codigo ? `${codigo} - ${formatcpfcnpj(cpfCnpj)} - ${nome}` : '';
    },

    onClear() {
      this.$emit('update:resultado', {});
    },

  },
};
</script>
